/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {RomanEmpireGameModuleConfig} from "./RomanEmpireGameModuleConfig";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireEvents} from "./events/RomanEmpireEvents";
import {RomanEmpireParsedInitData} from "./server/data/RomanEmpireParsedInitData";
import {REWinFieldController} from "./winpresentation/initial/REWinFieldController";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";

export class RomanEmpire extends SlotGame {

    constructor() {
        super(RomanEmpireGameModuleConfig.instance);
    }

    protected createWinFieldController(): WinFieldController {
        return new REWinFieldController();
    }

    protected initGame(): void {
        if (GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            // Reels.init();
            // WinterHoard.timelineReelsController = TimelineReelsController.instance;
            // WinterHoard.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        } else {
            super.initGame();
        }
    }

    init(): Promise<NolimitPlugin> {
        return super.init();
    }

    start(): Promise<NolimitPlugin> {
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_GAME_START));
        return super.start();
    }

    protected onInitDataParsed(data: RomanEmpireParsedInitData): void {
        super.onInitDataParsed(data);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M5",
                    "L1",
                    "M2"
                ],
                [
                    "L2",
                    "L1",
                    "L3"
                ],
                [
                    "M5",
                    "L4",
                    "L2"
                ],
                [
                    "L5",
                    "L1",
                    "M2"
                ],
                [
                    "L4",
                    "M4",
                    "L3"
                ]
            ],
            "evaluatedArea": [
                [
                    "M5",
                    "L1",
                    "M2"
                ],
                [
                    "L2",
                    "L1",
                    "L3"
                ],
                [
                    "M5",
                    "L4",
                    "L2"
                ],
                [
                    "L5",
                    "L1",
                    "M2"
                ],
                [
                    "L4",
                    "M4",
                    "L3"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "totalSpinWinningsMultiplied": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "numberOfRespinPlayed": 0,
            "newOverlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "winPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "wildMultipliersBefore": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "wildMultipliers": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "wildMultipliersNextSpin": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "overlayMultiplierWildsBefore": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayMultiplierWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "genieFeatureTriggered": false,
            "genieFeatureAwarded": "",
            "genieMultiplierAward": 0,
            "genieTimesBetCoinWin": 0,
            "genieOverlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "genieSymbolTriggerPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "genieExtraScatter": [
                -1,
                -1
            ],
            "numberOfGeniesInFS": 0,
            "featureBuyTimesBetValue": [
                {
                    "name": "GENIE_RESPIN",
                    "type": "FREESPIN",
                    "price": 80
                }
            ],
            "wasFeatureBuy": false,
            "randomBothWaysTriggered": false,
            "bothWayWins": [],
            "respinsRemaining": 0,
            "multiplierOverlays": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "goldenGenieMultiplierNextSpin": 1,
            "goldenGeniePositionCurrent": [
                -1,
                -1
            ],
            "goldenGeniePositionNextSpin": [
                -1,
                -1
            ],
            "isNoGenieSpin": false
        };
    }

    public getPaytable(): Promise<string> {
        const data = {
            showLowProbabilityGfx: RomanEmpire.api.gameClientConfiguration.showLowProbabilityGfx,
            showMultipliersforUSPA: RomanEmpire.api.gameClientConfiguration.jurisdictionName === "US-PA" ? true : RomanEmpire.api.gameClientConfiguration.showLowProbabilityGfx
        };

        return super.getPaytable().then((value: string) => {
            return RomanEmpire.api.translations.render(value, data);
        });
    }
}
